import Button from '../button/button';
import Typography from '../typography/typography';
/* eslint-disable no-mixed-spaces-and-tabs */
import './action-bar.scss';
import {
	/* IconButton, */ Box,
	CircularProgress,
	Divider,
	IconButton,
	Menu,
	MenuItem
} from '@mui/material';
import { useMediaQuery, useTheme } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ViewModal from '../view-modal/view-modal';
import HeaderCard from '../header-card/header-card';
import SearchBar from '../search-bar/search-bar';
import { useEffect, useMemo, useState } from 'react';
import images from '../../assets/images';
import Toggle from '../toggle/toggle';
import Filter from '../filter/filter';
import Select from '../select/select';
import { RuleGroupType } from 'react-querybuilder';
import SaveFilterModal from '../save-filter-modal/save-filter-modal';
import {
	setBaseUrl,
	postV1Filter,
	getV1FilterResource
} from '../../api-client/api.system-feature/api';
import type * as Types from '../../api-client/api.system-feature/api-types';
import { auth } from '../../constants/auth';
import DropdownButton from '../dropdown-button/dropdown-button';
import TitleDropdownButton from '../title-dropdown-button/title-dropdown-button';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { getToken } from '../../utils/common';
import React from 'react';
import UploadExcel from '../upload-excel/upload-excel';
import { generateQueryString, getErrorMessage, getExcelTemplateGenerateTemplate, getOperatorLabel, getExcelExportTemplate, getPdfExportTemplate } from '../../utils/common';
import { initialFilter, ViewType } from '@erpsquad/common/runtime';
import { usePages } from '@erpsquad/common/runtime';
import Chip from '../chip/chip';
import formatText, { formatLabel } from '../../utils/format-text';
import { Cancel } from '@mui/icons-material';
import { useLocation } from 'react-router-dom';
import { IResources, routeToResourceMap } from '../../constants/route-page-map';
import { enqueueSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { FilterRemove, Filter as FilterIcon, Search, FolderSave, Export, Import, DocumentDownload } from '../icons';
import { co } from 'node_modules/@fullcalendar/core/internal-common';

interface ActionData {
	label: string;
	position: number;
}
interface ActionBarPropsType {
	title: string;
	data: ActionData[];
	setData: React.Dispatch<React.SetStateAction<ActionData[]>>;
	active: string;
	setActive: (view: ViewType) => void;
	handleAddButton?: (e?: any) => void;
	button?: boolean;
	handleSearch?: (value: string) => void;
	filters?: string;
	disabledViews?: string[];
	isDropdownMenuButton?: boolean;
	itemListingDropdownOptions?: any;
	isTitleMenu?: boolean;
	titleMenus?: any;
	folderData?: any;
	type?: any;
	fields?: any;
	applyFilter?: any;
	savedFilters?: SavedFilter;
	setSavedFilters?: (view: SavedFilter) => void;
	isToggleButton?: boolean;
	handleToggleButton?: (e?: any) => void;
	showView?: boolean;
	showSearch?: boolean;
	showFilter?: boolean;
	customButtons?: React.ReactNode[] | JSX.Element[];
	actionBtn?: React.ReactNode[] | JSX.Element[];
	pageName?: string;
	importModuleName?: string;
	searchText?: string;
	selectedIds?: any;
	isUseFields?: boolean;
	handleSuccessImport?: (e?: any) => void;
}

interface SavedFilter {
	id: string;
	name: string;
	query: RuleGroupType;
}

const ActionBar = React.memo((props: ActionBarPropsType) => {
	const token = localStorage.getItem(auth.storageTokenKeyName) || undefined;
	const location = useLocation();

	const {
		title,
		data,
		setData,
		active,
		setActive,
		handleAddButton,
		handleSearch,
		button = true,
		disabledViews,
		isDropdownMenuButton = false,
		itemListingDropdownOptions = [],
		isTitleMenu = false,
		titleMenus = [],
		type,
		fields = [],
		applyFilter,
		// setSavedFilters,
		// savedFilters,
		isToggleButton = false,
		handleToggleButton,
		showSearch = true,
		showFilter = true,
		showView = true,
		customButtons,
		pageName,
		actionBtn,
		importModuleName,
		selectedIds,
		searchText,
		isUseFields,
		handleSuccessImport
	} = props;
	const dispatch = useAppDispatch();
	const [isToggled, setIsToggled] = useState<boolean>(false);
	const [isToggledForItem, setIsToggledForItem] = useState<boolean>(false);
	const [openFilterPopup, setOpenFilterPopup] = useState<boolean>(false);
	const [status, setStatus] = useState<string>('');
	const [openSaveFilter, setIsOpenSaveFilter] = useState<boolean>(false);
	const [rowAnchorEl, setRowAnchorEl] = useState<null | HTMLElement>(null);
	const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
	const [isDownloading, setIsDownloading] = useState(false);
	const [savedFilters, setSavedFilters] = useState<any[]>([]);
	// const [selectedSavedFilter, setSelectedSavedFilter] = useState<any>(null);
	const [searchedText, setSearchedText] = useState<string>("");
	const { t } = useTranslation();
	const theme = useTheme();
	const isLgUp = useMediaQuery(theme.breakpoints.up('xl'));
	const { activePage, updatePageInfo, schemaFields, setActivePage, customRouteToResourceMap } = usePages();
	const { filters } = activePage;
	const visibleTitleMenus = useMemo(
		() => (Array.isArray(titleMenus) ? titleMenus.filter((menu: any) => menu?.show) : []),
		[titleMenus]
	);

	const resources: IResources = useMemo(() => {
		const mergedMap = { ...routeToResourceMap, ...customRouteToResourceMap };
		return mergedMap[location.pathname] || null;
	}, [location.pathname, customRouteToResourceMap])
	const pageResourceName = resources?.pageResourceName;
	
	// const { filterBar, filterQuery } = useAppSelector((store) => {
	// 	return store?.drive;
	// });



	useEffect(() => {
		fetchSavedFilters();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const fetchSavedFilters = async (): Promise<void> => {
		if (resources?.pageResource || resources?.fieldResource) {
			getV1FilterResource({ ...getToken(), resource: resources?.pageResource || resources?.fieldResource })
				.then((response: any) => {
					const savedFilters = response.data.result.map((e: any) => {
						return { id: e._id, name: e.name, query: e.data };
					});

					setSavedFilters?.(savedFilters);
				})
				.catch((err: any) => console.log('Error fetching saved filters:', err));
		} else {
			setSavedFilters([])
		}
	};


	const handleFilterHide = () => {
		// dispatch(setFilterBar(false));
		return
	};

	const handleStatusChange = (event: any) => {
		setStatus(event.target.value);
	};

	const handleSaveFilterClick = () => {
		if (filters?.rules) {
			setIsOpenSaveFilter(true);
		}
	};

	const handleImportClick = (event: any) => {
		setRowAnchorEl(event.currentTarget);
	};

	const handleActionsClose = () => {
		setRowAnchorEl(null);
	};

	const handleSaveFilter = (query: RuleGroupType) => {
		// dispatch(setFilterQuery(query));
		return
	};

	const handleSave = async (name: string, filterQuery: RuleGroupType) => {

		// dispatch(setFilterBar(false));

		const postFilterRequest: Types.PostV1FilterRequest = {
			'x-token': token,
			module: resources?.pageResource || resources?.fieldResource || 'erp-common',
			name: name,
			is_applied: true,
			data: filterQuery
		};
		try {
			await postV1Filter(postFilterRequest)
			enqueueSnackbar('Filters saved successfully.')
			setActivePage((prev: any) => ({
				...prev,
				filters: {
					...prev.filters,
					name,
					rules: filterQuery.rules
				},
				filterQueryString: generateQueryString(filterQuery)
			}));
			setIsOpenSaveFilter(false);
		} catch (error) {
			let m: string = 'Something went wrong on saving filters'
			if (error instanceof Error) {
				m = getErrorMessage(error.message)
			}
			enqueueSnackbar(m, { variant: 'error' })
			return false
		}
		return true
	};

	const handleToggle = () => {
		setIsToggled((prev) => !prev);
		alert('Toggled');
	};

	const handleChangeToggleButton = () => {
		setIsToggledForItem((prev) => !prev);
		handleToggleButton?.();
	};

	const handleCloseFilter = () => {
		setOpenFilterPopup(false);
	};

	const handleActiveHeaderCard = (data: ActionData) => {
		setActive(data?.label);
	};

	const downloadTemplate = async (moduleName: string) => {
		setIsDownloading(true);
		try {
			const templateURL: any = await getExcelTemplateGenerateTemplate({
				'x-token': token,
				resource: moduleName
			});
			if (templateURL) {
				const blob = await templateURL.blob();
				const link = document.createElement('a');
				const url = window.URL.createObjectURL(blob);
				link.href = url;
				link.download = `${moduleName}.xlsx`;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				window.URL.revokeObjectURL(url);
			}
		} finally {
			setIsDownloading(false);
		}
	};

	const exportExcel = async (moduleName: string, filterQueryString: string, selectedIds: any, title: string) => {
		setIsDownloading(true);
		try {
			const columns = activePage.visible_columns.map((col: any) => ({
				...col,
				header: t(col.header)
			}));
			const templateURL: any = await getExcelExportTemplate({
				'x-token': token,
				activePage: activePage,
				filterQueryString: filterQueryString,
				selectedIds: selectedIds,
				title: title,
				columns: columns
			});
			if (templateURL) {
				const blob = await templateURL.blob();
				const link = document.createElement('a');
				const url = window.URL.createObjectURL(blob);
				link.href = url;
				link.download = `${moduleName}.xlsx`;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				window.URL.revokeObjectURL(url);
			}
		} finally {
			setIsDownloading(false);
		}
	};

	const exportPdf = async (moduleName: string, filterQueryString: string, selectedIds: any, title: string) => {
		setIsDownloading(true);
		try {
			const columns = activePage.visible_columns.map((col: any) => ({
				...col,
				header: t(col.header)
			}));
			const templateURL: any = await getPdfExportTemplate({
				'x-token': token,
				activePage: activePage,
				filterQueryString: filterQueryString,
				selectedIds: selectedIds,
				title: title,
				columns: columns
			});
			if (templateURL) {
				const blob = await templateURL.blob();
				const link = document.createElement('a');
				const url = window.URL.createObjectURL(blob);
				link.href = url;
				link.download = `${moduleName}.pdf`;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				window.URL.revokeObjectURL(url);
			}
		} finally {
			setIsDownloading(false);
		}
	};

	const openImportTemplate = () => {
		setIsUploadModalOpen(true);
	};
	const rowActionMenu = [];
	if (pageName && (!importModuleName || selectedIds)) {
		rowActionMenu.push({
			label: 'Export Excel',
			handleAction: (moduleName: string) => exportExcel(moduleName, generateQueryString(activePage.filters), selectedIds, title),
			icon: <Export fontSize='small' />
		})
	}
	if(pageName && (!importModuleName || selectedIds)){
		rowActionMenu.push({
			label: 'Export PDF',
			handleAction: (moduleName: string) => exportPdf(moduleName, generateQueryString(activePage.filters), selectedIds, title),
			icon: <Export fontSize='small'/>
		})
	}
	if (importModuleName) {
			rowActionMenu.push({
				label: 'Download Template ',
				handleAction: (moduleName: string) => downloadTemplate(moduleName),
				icon: <DocumentDownload fontSize='small' />
			},
				{
					label: 'Import Template',
					handleAction: () => openImportTemplate(),
					icon: <Import fontSize='small' />
				})
	}

	const getFilterChipLabels = (rule: any) => {
		rule = { ...rule, field: rule.field?.replace("__replaceKey", '') }
		let label = schemaFields.find((f: any) => f.key === rule.field)?.label || rule.field;
		label = formatLabel(label?.replace('_id', ' '));
		const opLabel = getOperatorLabel(rule, schemaFields);

		let value = rule.value;
		if (Array.isArray(rule.value)) {
			rule.value = rule.value.map(rv => formatLabel(typeof rv === 'object' ? (rv.label) : rv))
			value = rule.value.join(', ');
		}

		return <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
			<Typography type='s5' color='theme.secondary.800' weight='medium'>{label}</Typography>
			<Divider orientation='vertical' flexItem />
			<Typography type='s5' color='theme.primary.800' weight='medium'>{formatText(opLabel)} {value}</Typography>
		</Box>
		// `${label}: ${value}`;
	};

	const getFilterChip = (rr: any, index: any) => {
		return (
			<Chip
				label={getFilterChipLabels(rr)}
				variant='outlined'
				active
				sx={({ palette }) => ({
					backgroundColor: 'grey.200',
					borderColor: `${palette.grey[300]} !important`,
					opacity: 0.8,
					'&:hover': { backgroundColor: `${palette.grey[200]} !important` },
					flexDirection: 'row-reverse',
					alignItems: 'center',
					gap: 0.75,
					cursor: 'unset'
				})}
				deleteIcon={
					<Cancel
						sx={{
							fontSize: '1rem !important',
							color: '#919294 !important',
							marginRight: 'auto !important',
							marginLeft: `0 !important`,
							'&:hover': {
								color: 'inherit !important'
							}
						}}
					/>
				}
				onDelete={() => removeSignleFilter(index)}
				clickable={false}
			/>
		)
	}

	const removeSignleFilter = (ruleIndex: number) => {
		const uRules: any[] = filters.rules.filter(
			(_, index) => index !== ruleIndex
		);
		const uFilters = { ...filters, rules: uRules };
		const filterQueryString = generateQueryString(uFilters);

		updatePageInfo({
			filters: uFilters,
			filterQueryString
		});
	};

	const isFilterApplied = (flt: any): boolean => Boolean(flt?.rules?.length);
	const [searchAnchorEl, setSearchAnchorEl] = useState<HTMLElement | null>(null);
	// useEffect(() => {
	// 	if(activePage?.active_view ){
	// 		const updateViews=activePage?.views?.length?activePage.views:[{
	// 			label:activePage?.active_view,
	// 			position:0
	// 		}]
	// 		setData(updateViews)
	// 	}		
	// 	//eslint-disable-next-line
	// },[isCreatePage,activePage?.active_view])

	useEffect(() => {
		if (activePage?.search) {
			setSearchedText(activePage?.search)
		}
	}, [activePage?.search])

	useEffect(() => {
		if (searchedText) {
			handleSearch?.(searchedText);
			updatePageInfo({ search: searchedText });
		}
		//eslint-disable-next-line
	}, [searchedText])
	return (
		<div>
			<div className='action-bar'>
				<div className='action-bar--LeftContent'>
					{isTitleMenu ? (
						<div style={{ zIndex: 999 }}>
							<TitleDropdownButton
								onClick={handleAddButton}
								options={visibleTitleMenus}
								isMenuThirdItemDisabled={true}
								currentTitle={title}
							>
								{title}
							</TitleDropdownButton>
						</div>
					) : (
						<Typography type='h3' weight='medium' color='theme.secondary.1000'>
							{title}
						</Typography>
					)}
					<div className='action-bar--HeaderCard'>
						{Boolean(data) &&
							data
								.map((ele) => ele)
								.sort((a, b) => a.position - b.position)
								.map((item: ActionData) => (
									<HeaderCard
										key={item?.position}
										title={item?.label}
										active={active}
										onClick={() => handleActiveHeaderCard(item)}
									/>
								))}
						{showView && (
							<ViewModal
								setData={setData}
								data={data}
								setActive={setActive}
								disabledViews={disabledViews}
							/>
						)}
					</div>
				</div>

				<div className='action-bar--RightContent' style={{ gap: isLgUp ? `1rem` : `0.5rem` }}>
					{isToggleButton && (
						<div className='item--VariantDisplay'>
							<div className='item--VariantHeading'>Variant:</div>
							<div className='item--VariantToggal'>
								<Toggle
									checked={isToggledForItem}
									onChange={handleChangeToggleButton}
								/>
							</div>
						</div>
					)}
					{showSearch && (
						<>
							{isLgUp ?
								<SearchBar
									placeholder='Search'
									handleSearch={(e) => {
										setSearchedText(e);
										handleSearch?.(e);
									}}
									debounceTime={1000}
									isDrivePage={true}
									searchText={searchedText}
								/>
								:
								<>
									<IconButton size='small' onClick={(e) => setSearchAnchorEl(e.currentTarget)}><Search fontSize='small' color='grey.1000' /> </IconButton>
									<Menu
										anchorEl={searchAnchorEl}
										open={Boolean(searchAnchorEl)}
										onClose={() => setSearchAnchorEl(null)}
										anchorOrigin={{
											vertical: 'top',
											horizontal: 'right',
										}}
										transformOrigin={{
											vertical: 'top',
											horizontal: 'right',
										}}
										sx={{ '& ul': { p: 0 }, '& .MuiMenu-paper': { boxShadow: `0px 4px 6px rgba(0, 0, 0, 0.1), 0px 1px 3px rgba(0, 0, 0, 0.06);` } }}
									>
										<SearchBar
											placeholder='Search'
											handleSearch={(e) => {
												setSearchedText(e);
												handleSearch?.(e);
											}}
											debounceTime={1000}
											isDrivePage={true}
											searchText={searchText || searchedText}
										/>
									</Menu>
								</>
							}
						</>
					)}
					{showFilter && (
						<>
							{isLgUp ?
								<Button
									// sx={{display:"none"}}
									variant='text'
									startIcon={<FilterIcon fontSize='small' />}
									onClick={() => {
										setOpenFilterPopup(true);
										fetchSavedFilters();
									}}>
									{t('common.filter')}
								</Button>
								:
								<IconButton onClick={() => {
									setOpenFilterPopup(true);
									fetchSavedFilters();
								}} size='small'>
									<FilterIcon fontSize='small' color='grey.1000' />
								</IconButton>
							}
						</>
					)}

					{customButtons}
					{actionBtn}
					{button && (
						<Button
							variant='contained'
							startIcon={<AddIcon />}
							onClick={handleAddButton}>
							{t('common.add')}
						</Button>
					)}
					{isDropdownMenuButton && (
						<div style={{ zIndex: 999 }}>
							<DropdownButton
								onClick={handleAddButton}
								options={itemListingDropdownOptions}
								startIcon={<AddIcon />}
								isMenuThirdItemDisabled={true}>
								{t('common.add')}
							</DropdownButton>
						</div>
					)}

					{(pageName || importModuleName) ? (
						<IconButton onClick={(e) => !isDownloading && handleImportClick(e)} disabled={isDownloading}>
							{isDownloading ? (
								<CircularProgress size={20} color='inherit' />
							) : (
								<img src={images.more} alt='More Icon' />
							)}
						</IconButton>
					) : (
						''
					)}

					<Menu
						anchorEl={rowAnchorEl}
						open={Boolean(rowAnchorEl)}
						onClose={handleActionsClose}>
						{rowActionMenu?.map((option: any) => {
							const effectiveModuleName = pageName || pageResourceName;
							return (
								<MenuItem
									onClick={() => {
										if (!effectiveModuleName) return;
										option.handleAction(effectiveModuleName);
										setRowAnchorEl(null);
									}}
									sx={{ alignItems: 'center', gap: 0.5 }}
									disabled={
										!effectiveModuleName ||
										(typeof option.disabled === 'function'
											? option.disabled()
											: Boolean(option.disabled))
									}>
									{option?.icon}
									<Typography type='s4' color='inherit'>
										{option.label}
									</Typography>
								</MenuItem>
							);
						})}
					</Menu>

					<Filter
						open={openFilterPopup}
						onClose={handleCloseFilter}
						activeView={active}
						savedFilters={savedFilters}
						fetchSavedFilters={fetchSavedFilters}
						onSaveFilter={handleSaveFilter}
						type={type}
						isUseFields={isUseFields}
						fields={fields}
						onSelectedFilter={f => setSelectedSavedFilter(f)}
						applyFilter={applyFilter}
					/>
				</div>
			</div>

			{/* Applied Filters view (Start) */}
			{isFilterApplied(filters) && (
				<Box
					mb={1}
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between'
					}}>
					<Box
						mb={1}
						sx={{
							display: 'flex',
							alignItems: 'center',
							gap: 1,
							maxWidth: 400
						}}>
						<Typography type='s3' weight='medium' color='theme.secondary.1000'>
							{t('common.filters')}:{' '}
						</Typography>

						{filters?.rules?.map((r, rIndex) => (
							<>
								{r?.rules?.length ? (
									r?.rules?.map((rr, rrIndex) => (
										<>
											{getFilterChip(rr, rrIndex)}
										</>
									))
								) : <>
									{getFilterChip(r, rIndex)}

								</>
								}
							</>
						))}
					</Box>
					<Box>
						<Button
							variant='text'
							className='enable-filter-btn'
							startIcon={<FolderSave fontSize='small' />}
							onClick={handleSaveFilterClick}>
							<span> {t('common.saveFilter')}</span>
						</Button>
						{/* {selectedSavedFilter && 
							<Button
							variant='text'
							className='enable-filter-btn'
							startIcon={<img src={images.common.saveFilterIcon} alt='Add Icon' />}
							onClick={handleSaveFilterClick}>
								<Typography type='s3' color="theme.secondary.1000" weight='medium'>
									Update Filter <Typography type='s3' weight='medium'>{`(${selectedSavedFilter.name})`}</Typography>
								</Typography>
							</Button>
						} */}
						<Button
							variant='text'
							startIcon={<FilterRemove fontSize='small' />}
							onClick={() =>
								updatePageInfo({
									filters: initialFilter,
									filterQueryString: ''
								})
							}>
							{t('common.clearFilter')}
						</Button>
					</Box>
				</Box>
			)}
			{/* Applied Filters view (End) */}

			{/* {filterBar && (
				<div className='filter-bar'>
					<div className='filter-bar--LeftContent'>
						<div>
							<Select
								fullWidth
								placeholder='Placeholder'
								size={'small'}
								className='status-changes-drp'
								value={status}
								onChange={handleStatusChange}
								variant='outlined'>
								<MenuItem value={'Status'}>{t('common.status')}</MenuItem>
								<MenuItem value={'Show'}>{t('common.show')}</MenuItem>
							</Select>
						</div>
						<Typography className='subtask-switch' variant='h6'>
							{t('common.subtask')}
							<Toggle checked={isToggled} onChange={handleToggle} />
						</Typography>
						|
						<Button className='hide-btn' onClick={handleFilterHide}>
							{t('common.hide')}
						</Button>
					</div>
					<div className='filter-bar--RightContent'>
						<Button
							variant='text'
							className='enable-filter-btn'
							onClick={handleSaveFilterClick}>
							<img src={images.common.saveFilterIcon} alt='Add Icon' />
							<span>{t('common.saveFilter')}</span>
						</Button>
					</div>
				</div>
			)} */}
			<SaveFilterModal
				open={openSaveFilter}
				onClose={() => setIsOpenSaveFilter(false)}
				handleSubmit={(name: any) =>
					handleSave(name, filters as RuleGroupType)
				}
			/>
			<UploadExcel
				open={isUploadModalOpen}
				showCameraButton={false}
				onClose={() => setIsUploadModalOpen(false)}
				onConfirm={() => setIsUploadModalOpen(true)}
				title='Upload'
				multiple={false}
				importModuleName={importModuleName}
				pageName={importModuleName}
				handleSuccessImport={handleSuccessImport}
				accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
			/>
		</div>
	);
});

export { ActionBar };
export default ActionBar;
